import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

export default function SpinnerLoader({loading}) {
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(255,255,255,0.7)",
          zIndex: 10,
        }}
      >
        <ClipLoader
          size={50} // spinner size in px
          color={"#123abc"} // spinner color
          loading={loading} // show/hide
        />
      </div>
    </>
  );
}
